import React from 'react';
import ReactMarkdown, { Components } from 'react-markdown';
import styled from 'styled-components';

interface MarkdownRendererProps {
  children?: string;
  classname?: string;

  inline?: boolean;
}

const components: Components = {
  code(props) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { children, className, node, ...rest } = props;
    if (className?.includes(`vsly/json/recs`)) {
      return null;
    }

    return (
      <code className={className} {...rest}>
        {children}
      </code>
    );
  },
  a(props) {
    const { href } = props;

    const handler = () => {
      if (href) {
        window.postMessage(href);
      }
    };

    if ([`#edit-visual`, `#edit-code`, `#edit-strategy`].includes(href))
      return (
        <>
          <br />
          <EditButton onClick={handler}>{props.children}</EditButton>
        </>
      );
    return (
      <a href={props.href} target="_blank" rel="noreferrer">
        {props.children}
      </a>
    );
  },
};

export function MarkdownRenderer({
  children,
  classname,
  inline = false,
}: MarkdownRendererProps) {
  return (
    <Wrapper>
      <ReactMarkdown
        className={classname}
        components={{ ...(inline ? {} : components) }}
        linkTarget="_blank"
      >
        {children}
      </ReactMarkdown>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  br:not(:first-child) {
    display: none;
  }
`;

const EditButton = styled.button`
  appearance: none;
  outline: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: black;
  border: 1px solid black;
  padding: 0.5rem 1rem;
  border-radius: 2rem;
  transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;
  cursor: pointer;
  margin-top: 1rem;
  margin-right: 0.5rem;

  &:hover {
    background: black;
    color: white;
  }
`;
